import React, { useEffect, useState } from "react";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";

const ConfettiAnimation: React.FC = () => {
  const { width, height } = useWindowSize();

  return <Confetti width={width} height={height} recycle={false} numberOfPieces={1000} />;
};

export default ConfettiAnimation;
